var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',{staticClass:"Legend__title"},[_vm._v("Legenda")]),_c('ul',{staticClass:"Legend__list"},_vm._l((_vm.legends),function(legend){return _c('li',{key:legend.label},[_c('img',{attrs:{"width":"20","src":_vm.image({ name: legend.image })}}),_c('div',[_vm._v(" "+_vm._s(legend.label)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }